import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepFinanzasModule } from './rep-finanzas/rep-finanzas.module';
@NgModule({

  imports: [
    CommonModule,
    RepFinanzasModule,
  ],
  exports: [
    RepFinanzasModule
  ],
  declarations: [],



})
export class ReportesModule { }
